module.exports = {
  BACKUP: 1,
  EXPORT: 2,
  METADATA_COMPARE: 3,
  RESTORE: 4,
  SETTINGS: 5,
  API_USAGE: 6,
  ROLES: 7,
  ACTIVITY_HISTORY: 9,
  GDPR: 10,
  EXTERNAL_API_CREDENTIALS: 11,
  IT_COMPLETE_FEATURE: 12,
  //RETENTION: 13
};
